const INFO = {
	main: {
		title: "Reactfolio",
		name: "Nicolas Lemuel",
		email: "lemuelayres@gmail.com",
		logo: "../nanamin.jpg",
	},

	socials: {
		twitter: "https://twitter.com/nlim_a",
		github: "https://github.com/nlemuel",
		linkedin: "https://www.linkedin.com/in/nicolas-de-lima-23137718b/",
	},

	homepage: {
		title: "Desenvolvedor no final de sua jornada na busca de seu diploma de Análise e desenvolvimento de sistemas",
		description:
			"Aluno da FATEC apaixonado por dados e front-end desde o terceiro semestre do curso, aprendendo sobre Typescript, IA e Python. Gosto de resolver problemas, aprender habilidades novas e as vezes crio alguns problemas também. Procuro por oportunidades para aprimorar minhas habilidades como desenvolvedor web.",
	},

	about: {
		title: "Me chamo Nicolas Lemuel. Moro em São José dos Campos, cidade conhecida por estar a 1 hora de qualquer cidade do Brasil, aqui é onde estou construindo minha base para dar grandes saltos no futuro.",
		description:
			"Minha primeira experiência profissional na área de TI foi como estagiário na Vivo Telefônica, lá aprendi muito não apenas sobre habilidades técnicas mas também sobre as soft skills necessárias para um bom trabalho em equipe. Passei por alguns desafios onde apenas o conhecimento técnico não foi o sufiente para chegarmos a entrega final. Sai de lá com uma grnade bagagem de aprendizado e com muita vontade de aplicá-lo, atualmente estou engajando em comunidades open source para contribuir com projetos adquirindo mais experiência.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Altave",
			description:
				"Projeto de visão computacional, ainda em desenvolvimento, realizado com a Altave pela FATEC",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/CodeLabFatec/ProjetoIA",
		},

		{
			title: "App Masters",
			description:
				"Teste técnico desenvolvido para a empresa App Masters",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/nlemuel/games-front-test",
		},

		{
			title: "API Iacit",
			description:
				"Projeto realizado na faculdade com parceria da empresa Iacit. Nosso time resolveu um problema real da empresa utilizando React Native, Node.JS e a metodologia ágil Scrum.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/PowerTech5API/iacity",
		},

		{
			title: "Ensinio",
			description:
				"Teste técnico para a Ensinio, plataforma de cursos online",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/nlemuel/hero-section",
		},

		// {
		// 	title: "Project 5",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },
	],
};

export default INFO;
